export type NavigationItem = {
  label: string;
  to: string;
  cta?: boolean;
};

export const getPrimaryNavigation = (t: (key: string) => string): NavigationItem[] => [
  { label: t('nav.home'), to: '/' },
  { label: t('nav.about'), to: '/about' },
  { label: t('nav.services'), to: '/services' },
  { label: t('nav.portfolio'), to: '/portfolio' },
  { label: t('nav.contact'), to: '/contact', cta: true },
];
